import { useEffect, useMemo, useState } from 'react';
import type { ViewKey } from './BottomNav';
import { BottomNav } from './BottomNav';
import { SideNav } from './SideNav';
import { DashboardView } from '../dashboard/DashboardView';
import { LibraryView } from '../library/LibraryView';
import { ProgressView } from '../progress/ProgressView';
import { ToastHost } from '../ui/ToastHost';
import { bootstrapSync, dateKey } from '../../lib/setProgress';

export function AppShell(): JSX.Element {
  const [view, setView] = useState<ViewKey>('dashboard');
  const today = useMemo(() => new Date(), []);
  const dayKey = useMemo(() => dateKey(today), [today]);

  useEffect(() => {
    bootstrapSync();
  }, []);

  return (
    <div className="min-h-dvh md:flex">
      <SideNav active={view} onChange={setView} />
      <div className="flex-1 pb-16 md:pb-0">
        {view === 'dashboard' ? <DashboardView today={today} /> : null}
        {view === 'library' ? <LibraryView dayKey={dayKey} /> : null}
        {view === 'progress' ? <ProgressView /> : null}
      </div>
      <ToastHost />
      <div className="md:hidden">
        <BottomNav active={view} onChange={setView} />
      </div>
    </div>
  );
}
